/**
 * Marketing pages that take no marketing shell (INCO-544).
 *
 * Everything under `pages/marketing/` gets `MarketingLayout` by resolution,
 * in the browser and on the server alike. `/start` is the exception: it
 * wears the marketing site's sign-up design, which stands alone with no nav
 * or footer, as the site's own auth pages did. Listed here, once, so both
 * resolvers agree and no page has to assign its own layout.
 */
export const STANDALONE_PAGES: ReadonlySet<string> = new Set(["marketing/start"])
